import React from "react"

const ActivityIndicator: React.FunctionComponent<{
    className?: string
}> = ({ className }) => {
    return (
        <div className="flex">
            <div className={["inline", className].filter((each) => each && each.length > 0).join(" ")}>
                <i className="fas fa-spinner animate-spin" />
            </div>
        </div>
    )
}

export default ActivityIndicator
